import React, { useState } from 'react';
import debounce from 'debounce';

import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button'
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';

import QualificationInput from './QualificationInput';

const useStyles = makeStyles((theme) => ({
    paper: {
        marginTop: theme.spacing(2),
        padding: theme.spacing(1),
    },
    field: {
        margin: theme.spacing(1),
    }
}));

const MemberEducation = ({ subject, title, items = [], onChange }) => {
    const [courses, setCourses] = useState(items);
    const classes = useStyles();

    const handleChange = debounce((changeItemIndex, fragment) => {
        const updated = courses.map((item, index) => {
            return index === changeItemIndex ? { ...item, ...fragment } : item;
        });

        onChange({[subject]: updated});
        setCourses(updated);
    }, 500);

    const addNewRow = () => {
        setCourses([...courses, { course: '', institution: '', year: '' }]);
    }

    const deleteRow = index => {
        const remainder = courses.filter((_, i) => i !== index);
        setCourses(remainder);
        onChange({[subject]: remainder});
    }

    return (
        <Paper className={classes.paper}>
            <Typography variant="h6" color="initial">{title}</Typography>
            {
                courses.map((item, index) => {
                    return (
                       <QualificationInput key={`${subject}-${index}`} index={index} item={item} onChange={handleChange} onDelete={deleteRow} classes={classes} />
                    )
                })
            }
            <Button variant="contained" color="primary" className={classes.field} onClick={addNewRow}>
                Add another row
            </Button>

        </Paper>

    );
};

export default MemberEducation;